// extracted by mini-css-extract-plugin
export var divider = "_un-0";